import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class LyftDispatchRideStatus extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;
}
